/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $InputText} from '@gongxigames/framework/core/fragments/BuilderY';
import {Signal} from '@gongxigames/framework/core/fragments/store/Store';

export type $AutoplayInputProps = {
    inputValue: Signal<string>;
    onInput: (value: string) => void;
    onFocus: () => void;
    onBlur: () => void;
};

export const $AutoplayInput: FC<$AutoplayInputProps> = (props) => {
    const {onInput, onFocus, onBlur, inputValue} = props;

    return <$InputText
        text={inputValue}
        textStyle={{
            padding: '8px',
            width: '500px',
            fontFamily: 'Exo DemiBold',
            fontSize: '47px',
            color: '#ffffff',
            textAlign: 'center',
            fontWeight: 'lighter'
        }}
        boxStyle={{
            default: {
                fill: 0x000000,
                rounded: 20,
                stroke: {color: 0x767676, alpha: 1, width: 4}
            }
        }}
        position={[530, -40]}
        disabledPasteFromClipboard={true}
        inputEvents={{
            input: onInput,
            focus: onFocus,
            blur: onBlur,
        }}
    />;
};
